<template>
  <div class="p-inputgroup">
    <span class="p-inputgroup-addon">{{ labelstring }}</span>
    <PrimeCalendar
      v-model="v_beginDate"
      selectionMode="single"
      dateFormat="yy/mm/dd"
      @date-select="onChange_Begin($event)"
    />
    <span class="p-inputgroup-addon">To</span>
    <PrimeCalendar
      v-model="v_endDate"
      selectionMode="single"
      dateFormat="yy/mm/dd"
      @date-select="onChange_End($event)"
    />
  </div>
</template>

<script>
export default {
  props: ["beginDate", "endDate", "labelstring"],
  emits: ["update:beginDate", "update:endDate"],

  data() {
    return {
      v_beginDate: null,
      v_endDate: null,
    };
  },
  created() {
    this.v_beginDate = this.beginDate;
    this.v_endDate = this.beginDate;
  },
  methods: {
    onChange_Begin(event) {
      console.log(event);
      this.$emit("update:beginDate", this.v_beginDate);
      this.$emit("change_begin", this.v_beginDate);
    },
    onChange_End(event) {
      console.log(event);
      this.$emit("update:endDate", this.v_endDate);
      this.$emit("change_end", this.v_endDate);
    },
  },
};
</script>
